import React, { useState, useEffect } from 'react'
import { DashboardLayout, MultiFilters, GeneralTable, Button, Toaster, ConfirmationModal } from 'components'
import { useCustomSelector } from 'hooks';
import { useTableColumns } from './hooks/useTableColumns';
import { isNotNullUndefined, isObjectEmpty, isObjectNotEmpty, isArrayNotEmpty, isArrayEmpty, deepCloneObject, isNullUndefined, isStringNotEmpty, isStringEmpty } from 'functions';
import useCommitmentPaySetup from 'dataflow/billingPortal/actions/useCommitmentPaySetup.actions';
import { useOutletTableColumns } from './hooks/useOutletTableColumns';
import 'assets/scss/billingPortal/modules/commitmentPaySetup/commitment_update.scss';
import ic_add_account from "assets/images/ic_add_account.svg";
import useAddKey from './hooks/useAddKey';
import { monthYearDifference, distinctById, addMonthYear, convertISOToMonthYear } from './hooks/func_custom';
import { useConfirmation } from './hooks/useConfirmation';
import ic_collapse_arrow from "assets/images/ic_collapse_arrow.svg";
import { subsidiaryList } from 'constants/lists';

export default function CommitmentPaySetup(props) {

    const [selectedCommitment, setselectedCommitment] = useState()
    const [isInvoices, setIsInvoices] = useState(false)
    let clicks = 0; // variable to detect double click

    const [outletList, setoutletList] = useState([])
    const [keyList, setkeyList] = useState([])
    const [balanceQuantity, setbalanceQuantity] = useState(0)
    const [selectedbalanceQuantity, setSelectedbalanceQuantity] = useState(0)
    const [selectedOutlets, setselectedOutlets] = useState([])
    const [selectedOutletsIndex, setselectedOutletsIndex] = useState([])
    const [selectedkeyList, setSelectedKeyList] = useState([])
    const [monthQuantity, setMonthQuantity] = useState(0)

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    let { 
        getRevRecPlanList_requesting, revRecPlanList, revRecPlanListTotalRecords, updatePlan_requesting, isPlanUpdatedSuccessfully,
        getPlanByComId_requesting, getPlanByComId_isSuccessful, currentPlan, switchCommitmentPlan_requesting
    } = useCustomSelector("commitmentPaySetup");

    const { getRevRecPlanList, getPlanByComId, updatePlan, switchCommitmentPlan } = useCommitmentPaySetup();

    // main columns
    const mainColumns = useTableColumns();

    // invoices columns
    const invoicesColumns = useOutletTableColumns();

    const {
        isModalVisible: isAddKeyModalVisible,
        setIsModalVisible: setIsAddKeyModalVisible,
        modalDisplay: addKeyModal,
    } = useAddKey({ keyList, selectedkeyList, setSelectedKeyList });

    useEffect(() => {
        if(!isAddKeyModalVisible) {
            if(isArrayNotEmpty(selectedkeyList)) {
                setoutletList(prevState => [...prevState, ...selectedkeyList])

                // reset
                setSelectedKeyList([])
            }
        }
    }, [isAddKeyModalVisible])

    useEffect(() => {
        if(isInvoices) {
            if(isObjectNotEmpty(selectedCommitment)) {
                setbalanceQuantity(selectedCommitment?.totalQuantity)
                setMonthQuantity(selectedCommitment?.qty_of_month)

                let paramObj = {
                    ComId: selectedCommitment?.customerData?.comId,
                    RevenueRecPlan_InternalId: selectedCommitment?.revenuePlanInternalId
                }
                getPlanByComId(paramObj)
            }
        }
    }, [isInvoices])

    useEffect(() => {
        if(getPlanByComId_requesting === false && getPlanByComId_isSuccessful === true && currentPlan) {
            let data = currentPlan?.plans[0]?.referenceKeyInfo
            let outletListArr = []
            let keyListArr = []
            let selectedOutletsListArr = []
            let selectedOutletsIndexListArr = []

            // get and reaarange outlet list for applied to be on top of list
            if(isArrayNotEmpty(data)) {
                data.map((outlet) => {
                    if(outlet.hasApplied) {
                        outletListArr.unshift(outlet)
                    }
                    else {
                        outletListArr.push(outlet)
                    }

                    keyListArr.push({
                        ...outlet,
                        startDate: null,
                        endDate: null,
                        hasApplied: false
                    })
                })
            }

            // get selected outlet
            if(isArrayNotEmpty(outletListArr)) {
                outletListArr.map((outlet, index) => {
                    if(outlet.hasApplied) {
                        selectedOutletsListArr.push(outlet)
                        selectedOutletsIndexListArr.push(index)
                    }
                })  
            }
            setoutletList([...outletListArr])
            setselectedOutlets([...selectedOutletsListArr])
            setselectedOutletsIndex([...selectedOutletsIndexListArr])
            setkeyList([...distinctById(keyListArr, "chargeKey")])
        } 
        else {
            setoutletList([])
        }
    }, [getPlanByComId_requesting])

    useEffect(() => {
        let totalMonthDiff = 0
        if(isArrayNotEmpty(selectedOutletsIndex)) {
            selectedOutletsIndex.map(index => {
                let filtered_outletList = outletList[index]
                // calculate credit balance
                if(isNotNullUndefined(filtered_outletList?.startDate) && isStringNotEmpty(filtered_outletList?.startDate) 
                    && isNotNullUndefined(filtered_outletList?.endDate) && isStringNotEmpty(filtered_outletList?.endDate)) {
                    let monthDiff = monthYearDifference(filtered_outletList?.startDate, filtered_outletList?.endDate)
                    totalMonthDiff = totalMonthDiff + monthDiff
                }
            })
        }
        setSelectedbalanceQuantity(totalMonthDiff)
    }, [outletList, selectedOutletsIndex])

    useEffect(() => {
        if(isPlanUpdatedSuccessfully) {
            setIsInvoices(false);
            setselectedCommitment(undefined);
            setoutletList([]);
        }
    }, [isPlanUpdatedSuccessfully])

    const updateDate = (rowIndex, columnId, value) => {
        let convertedValue = convertISOToMonthYear(value)
        setoutletList(outlet =>
            outlet.map((row, index) => {
                if (index === rowIndex) {

                    let obj = {
                        ...outlet[rowIndex],
                        [columnId]: convertedValue,
                    }

                    if(columnId !== 'endDate' && (isNullUndefined(obj?.endDate) || isStringEmpty(obj?.endDate))) {
                        let defaultEndDate = addMonthYear(value, monthQuantity)
                        obj.endDate = convertISOToMonthYear(defaultEndDate)
                    }

                    return obj
                }
                return row
            })
        )
    }

    const onChangeStatus = (rowIndex, columnId, active, data) => {
        setoutletList(outlet =>
            outlet.map((row, index) => {
                if (index === rowIndex) {

                    let obj = {
                        ...outlet[rowIndex],
                        [columnId]: active,
                        ...(!active)? {quotationReminder: false}:{}
                    }

                    return obj
                }
                return row
            })
        )

        if(active) {
            setselectedOutlets(prevState => [...prevState, data])
            setselectedOutletsIndex(prevState => [...prevState, rowIndex])
        }
        else {
            setselectedOutlets(prevState => prevState.filter(obj => obj.chargeValue !== data.chargeValue))
            setselectedOutletsIndex(prevState => prevState.filter(obj => obj !== rowIndex))
        }
    }

    const onChangeQuotationReminder = (rowIndex, columnId, active) => {
        setoutletList(outlet =>
            outlet.map((row, index) => {
                if (index === rowIndex) {

                    let obj = {
                        ...outlet[rowIndex],
                        [columnId]: active,
                    }

                    return obj
                }
                return row
            })
        )
    }

    function startEndMonthValidation(outlets) {
        if(isArrayNotEmpty(outlets)) {
            let filtered_outlets = outlets.filter(x => (isNullUndefined(x?.startDate) || isStringEmpty(x?.startDate) || isNullUndefined(x?.endDate) || isStringEmpty(x?.endDate)))
            if(isArrayNotEmpty(filtered_outlets))
                return false
        }
        return true
    }

    function validationRequired() {
        let filtered_selectedOutlet = [...selectedOutletsIndex.map(index => {
            return outletList[index]
        })]
        if(isArrayEmpty(filtered_selectedOutlet)) {
            Toaster({ type: "info", msg: "No key is selected" });
            return false
        }
        else if(!startEndMonthValidation(filtered_selectedOutlet)) {
            Toaster({ type: "info", msg: "One of the selected start/end month input is empty" });
            return false
        }
        else if((balanceQuantity - selectedbalanceQuantity) < 0) {
            Toaster({ type: "info", msg: "Exceeded balance amount" });
            return false
        }
        return true
    }

    function handleOnSave() {
        if(validationRequired()) {
            let updatedPlan = deepCloneObject(currentPlan);
            updatedPlan.plans[0].referenceKeyInfo = [...selectedOutletsIndex.map(index => {
                return outletList[index]
            })]
            updatePlan(updatedPlan)
        }
    }

    function handleOnCancel() {
        setIsInvoices(false);
        setselectedCommitment(undefined);
        setoutletList([]);
    }

    const {
        modalDisplay: confirmModal,
        setIsModalVisible: setIsConfirmModalVisible
    } = useConfirmation({ handleOnSave, updatePlan_requesting,  isPlanUpdatedSuccessfully})

    let mainDisplay = (
        <GeneralTable
            className={"commitment-pay-setup__main-table"}
            columns={mainColumns}
            data={userPermissions?.Internal_ManipulateRevenuePlan_Update? revRecPlanList: []}

            getTableData={getRevRecPlanList}
            onRowClick={(rowDetails) => {
                clicks++;
                let data = rowDetails?.original;
                
                setTimeout(function() {
                    if (clicks > 1 && isObjectNotEmpty(data)) {
                        if(isNotNullUndefined(data?.revenuePlanInternalId)) {
                            setselectedCommitment(data);
                            setIsInvoices(true);
                        }
                    }
                    clicks = 0;
                }, 300);
            }}

            outerTableHeader={(outerTableHeader_props) => {
                const { 
                    filterOptions, setFilterOptions
                } = outerTableHeader_props;

                return (
                    <div className={"table__headers"}>
                        {/* Top Section */}
                        <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                            {/* Title */}
                            <div className={"headers__title tableHeaderTitle "}>
                                List
                            </div>

                            <Button
                                className={"headers__switch-button"}
                                handleOnClick={() => switchCommitmentPlan()}
                                isLoading={switchCommitmentPlan_requesting}
                                isDisabled={switchCommitmentPlan_requesting}

                            >
                                Switch to Commitment Plan
                            </Button>
                        </div>

                        {/* Bottom Section */}
                        <div className={"headers__bottom-section"}>
                            <MultiFilters
                                defaultFilterOption={{
                                    label: "Company ID", 
                                    propertyName: "comId",
                                    placeholder: "Company ID",
                                    inputType: "search",
                                }}
                                filterOptions={[
                                    {
                                        label: "Company ID", 
                                        propertyName: "comId",
                                        placeholder: "Company ID",
                                        inputType: "search",
                                    },
                                    {
                                        label: "Account Code", 
                                        propertyName: "accountCode",
                                        placeholder: "Account Code",
                                        inputType: "search",
                                    },
                                    {
                                        label: "Product Code", 
                                        propertyName: "ProductCode",
                                        placeholder: "Product Code",
                                        inputType: "search",
                                    },
                                    {
                                        label: "Plan Number", 
                                        propertyName: "planNo",
                                        placeholder: "Plan Number",
                                        inputType: "search",
                                    },
                                    {
                                        label: "Source Number", 
                                        propertyName: "sourceNo",
                                        placeholder: "Source Number",
                                        inputType: "search",
                                    },
                                    {
                                        label: "Status", 
                                        propertyName: "status",
                                        placeholder: "Status",
                                        options: [{ label: "Completed", value: "Completed" }, { label: "Active", value: "Active" }],
                                        inputType: "dropdown"
                                    },
                                    {
                                        label: "Subsidiary", 
                                        propertyName: "subsidiary",
                                        placeholder: "Subsidiary",
                                        options: [{ label: "All", value: "" }].concat(subsidiaryList),
                                        inputType: "dropdown"
                                    }
                                ]}
                                dropdownPlaceholder={"Select Filter"}
                                onApplyFilter={(inputFilters) => {
                                    setFilterOptions(isObjectEmpty(inputFilters)? {}: { ...filterOptions, ...inputFilters});
                                }}
                            />
                        </div>
                    </div>
                );
            }}
            
            isTableDataLoading={getRevRecPlanList_requesting}

            isUsingPagination
            totalRecords={revRecPlanListTotalRecords}
            isTableRefreshRequired={isPlanUpdatedSuccessfully}

            isExpanderRequired isRowExpanderColumnFirst
            isColumnResizeable
            isTableOddRowsDarken
        />
    )

    let invoicesDisplay = (
        <div className='commitment-pay-setup__invoices'>
            <GeneralTable
                className={"commitment-pay-setup__invoices-table"}
                columns={invoicesColumns.invoicesCol}
                data={outletList}
                tableWrapperClassName={"commitment-pay-setup__invoices-tableWrapper"}
                tableOptions={{
                    updateDate, onChangeStatus, onChangeQuotationReminder
                }}
                totalRecords={isArrayNotEmpty(outletList)? outletList.length:0}
                isTableDataLoading={getPlanByComId_requesting}
                outerTableHeader={(outerTableHeader_props) => {
                    const { 
                        filterOptions, setFilterOptions
                    } = outerTableHeader_props;

                    return (
                        <div className={"table__headers"}>

                            {/* Add key modal */}
                            {addKeyModal}

                            {/* Confirmation Modal */}
                            {confirmModal}

                            {/* Top Section */}
                            <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                {/* Title */}
                                <div className={"headers__subtitle d-flex"}>
                                    <Button
                                        className={"headers__back-button"}
                                        handleOnClick={handleOnCancel}
                                    >
                                        <img
                                            className={"headers__back-arrow"}
                                            src={ic_collapse_arrow}
                                            alt={"Back Arrow"}
                                        />
                                    </Button>
                                    Invoices - {selectedCommitment?.sourceNumber}
                                </div>

                                {/* Add Key */}
                                <Button
                                    className={"headers__add-button"}
                                    handleOnClick={() => setIsAddKeyModalVisible(true)}
                                    isDisabled={getPlanByComId_requesting}
                                >
                                    <img
                                        className={"px-2"}
                                        src={ic_add_account}
                                        alt={"Add Icon"}
                                    />
                                    Add Key
                                </Button>
                            </div>
                        </div>
                    );
                }}
            />
            <div className='commitment-pay-setup__invoices-footer'>
                <div className='d-flex align-items-center'>
                    <div className='commitment-pay-setup__invoices-footer__text flex-grow-1'>
                        Credit balance: {balanceQuantity - selectedbalanceQuantity}
                    </div>
                    <div className='d-flex flex-row'>
                        <div className='px-2'>
                            <Button
                                className={"commitment-pay-setup__invoices-footer__cancel-button"}
                                handleOnClick={handleOnCancel}
                            >
                                Cancel
                            </Button>
                        </div>
                        <div className='px-2'>
                            <Button
                                className={"commitment-pay-setup__invoices-footer__save-button"}
                                handleOnClick={() => setIsConfirmModalVisible(true)}
                                isDisabled={getPlanByComId_requesting || updatePlan_requesting}
                                isLoading={updatePlan_requesting}
                            >
                                Save
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    return (
        <DashboardLayout
            headerTitle={"Commitment Pay Setup"}

            bodyClassName={"commitment-pay-setup"}
            isHeaderCloseIconVisible={isInvoices}
            updateParentState_visiblity={isInvoices? setIsInvoices:null}
            onClose={() => {
                setselectedCommitment(undefined);
                setoutletList([]);
            }}
            body={isInvoices? invoicesDisplay:mainDisplay}
        />
    )
}